"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toISOString;
function toISOString(date) {
  if (typeof date === 'object' && date !== null) {
    var isoString = date.toISOString();
    return [isoString.slice(0, 19), isoString.slice(23)].join('');
  }
  if (typeof date === 'string' && date.length > 0) {
    return date;
  }
  return undefined;
}